import { useAlert } from "@/src/common/Alert";
import {
  ListSectionHeader,
  ListSectionHeaderTitle,
} from "@/src/components/atoms/ListSectionHeader";
import { LazyQueryNetworkBoundrary } from "@/src/components/mobile/QueryNetworkBoundrary";
import { useIntlTokens } from "@/src/components/mobile/useIntlTokens";
import {
  useLayoutContext,
  useTheme,
  Box,
  Card,
  AHInput,
  AHSeparator,
  AHButton,
} from "arkh";
import React, { useState } from "react";
import { ScrollView } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useMutation } from "react-relay";
import { graphql } from "relay-runtime";

import { ActivateFeaturesPLUMutation } from "./__generated__/ActivateFeaturesPLUMutation.graphql";
import { ActivateFeaturesPLUTemplateMutation } from "./__generated__/ActivateFeaturesPLUTemplateMutation.graphql";
import { ActivateFeaturesPLUClearPLUMutation } from "./__generated__/ActivateFeaturesPLUClearPLUMutation.graphql";
import { StoreAdminNavigationScreenProps } from "../StoreAdmin/StoreAdminNavigation";

export function ActivateFeaturesPLU(
  props: {
    fetchKey: string;
  } & StoreAdminNavigationScreenProps<"SuperAdminPanel">
) {
  const layout = useLayoutContext();
  const insets = useSafeAreaInsets();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const [activatePlu, loading] = useMutation<ActivateFeaturesPLUMutation>(
    graphql`
      mutation ActivateFeaturesPLUMutation(
        $username: String!
        $password: String!
      ) {
        activatePLUFromInfoTab(password: $password, username: $username) {
          pluCategories {
            id
          }
        }
      }
    `
  );

  const [activatePluFromTemplate, activatePluFromTemplateLoading] =
    useMutation<ActivateFeaturesPLUTemplateMutation>(graphql`
      mutation ActivateFeaturesPLUTemplateMutation {
        activatePLU {
          pluCategories {
            id
          }
        }
      }
    `);

  const [clearPLU, clearingPlu] =
    useMutation<ActivateFeaturesPLUClearPLUMutation>(graphql`
      mutation ActivateFeaturesPLUClearPLUMutation {
        clearPLU {
          id
        }
      }
    `);

  const theme = useTheme();

  const Alert = useAlert();

  const intl_tokens = useIntlTokens();

  return (
    <>
      <Box spaceVertical="large" />
      <ListSectionHeader>
        <ListSectionHeaderTitle>
          Aktivera PLU från InfoTab
        </ListSectionHeaderTitle>
      </ListSectionHeader>
      <Card>
        <AHInput
          cornerRadius="large"
          space="medium"
          color="surface"
          placeholder="Användarnamn"
          value={username}
          textContentType="username"
          onChangeText={setUsername}
        />
        <AHSeparator />
        <AHInput
          cornerRadius="large"
          space="medium"
          color="surface"
          textContentType="password"
          secureTextEntry
          placeholder="Lösenord"
          onChangeText={setPassword}
          value={password}
        />
        <AHSeparator />
        <Box spaceVertical="medium">
          <AHButton
            themeType="primary"
            disabled={password.length === 0 || username.length === 0}
            onPress={() => {
              activatePlu({
                variables: {
                  username,
                  password,
                },
                onCompleted: () => {
                  Alert.alert("PLU importerat!");
                  props.navigation.goBack();
                },
                onError: () => {
                  Alert.alert(
                    "Fel inträffade",
                    "kontrollera användarnamn och lösenord"
                  );
                },
              });
            }}
            loading={loading}
            title={intl_tokens.Activate}
          />
        </Box>
      </Card>
      <Box spaceVertical="small" />
      <Card>
        <Box spaceVertical="medium">
          <AHButton
            themeType="primary"
            onPress={() => {
              Alert.alert(
                "Säker på att du vill importera produkter från basplåt?",
                "",
                [
                  {
                    isPreferred: true,
                    onPress: () => {},
                    text: "Avbryt",
                  },
                  {
                    text: "Ja Importera",
                    style: "destructive",
                    onPress: () => {
                      activatePluFromTemplate({
                        variables: {},
                        onCompleted: () => {
                          Alert.alert("PLU importerat från basplåt!");
                        },
                        onError: () => {
                          Alert.alert("Fel inträffade");
                        },
                      });
                    },
                  },
                ]
              );
            }}
            loading={activatePluFromTemplateLoading}
            title="Aktivera PLU från basplåt"
          />
        </Box>
        <Box spaceVertical="medium">
          <AHButton
            themeType="negative"
            onPress={() => {
              Alert.alert("Säker på att du vill rensa?", "", [
                {
                  isPreferred: true,
                  onPress: () => {},
                  text: "Avbryt",
                },
                {
                  text: "Ta bort alla produkter",
                  style: "destructive",
                  onPress: () => {
                    clearPLU({
                      variables: {},
                      onCompleted: () => {
                        Alert.alert("PLU Rensat!");
                      },
                      onError: () => {
                        Alert.alert("Fel inträffade");
                      },
                    });
                  },
                },
              ]);
            }}
            loading={clearingPlu}
            title="Ta bort alla produkter och kategorier"
          />
        </Box>
      </Card>
      <Box spaceVertical="large" />
      <AHButton
        themeType="primary"
        onPress={() => {
          props.navigation.navigate("ActivatePLUFromStoreOffice", {});
        }}
        title="Importera PLU från StoreOffice"
      />
    </>
  );
}
